import {styled} from "styled-components";
import {IonText} from "@ionic/react";

export const ErrorMessage = styled(IonText).attrs({color: "danger"})`
  font-size: 12px;
`;
